import PracticeAreaFilterWidget from 'cle/practice_area_filter_widget'
import CLECoursesSearchController from 'controllers/cle_courses_search_controller'

export default class extends CLECoursesSearchController {
  static values = {
    ...super.values,
    practiceAreaName: String
  }

  searchOptions() {
    const options = super.searchOptions()

    return {
      ...options,
      facets: {
        ...options.facets,
        practice_areas: false
      },
      practiceAreaName: this.practiceAreaNameValue
    }
  }
}
